import { useCallback, useEffect, useState } from "react";

const STORAGE_KEY = "gpm_recently_viewed";
const MAX_ITEMS = 12;

/** Store lightweight snapshots of viewed properties so Home can show a "Recently Viewed" strip
 *  without an extra API call. Each item is { id, title, price, city, locality, image, listing_type, property_type, bhk, viewedAt }. */
export function useRecentlyViewed() {
    const [items, setItems] = useState(() => {
        try {
            const raw = localStorage.getItem(STORAGE_KEY);
            return raw ? JSON.parse(raw) : [];
        } catch {
            return [];
        }
    });

    useEffect(() => {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    }, [items]);

    const push = useCallback((property) => {
        if (!property || !property.id) return;
        setItems((prev) => {
            const snapshot = {
                id: property.id,
                title: property.title,
                price: property.price,
                city: property.city,
                locality: property.locality,
                image: property.images?.[0] || null,
                listing_type: property.listing_type,
                property_type: property.property_type,
                bhk: property.bhk,
                area_sqft: property.area_sqft,
                bathrooms: property.bathrooms,
                viewedAt: new Date().toISOString(),
            };
            const filtered = prev.filter((x) => x.id !== snapshot.id);
            return [snapshot, ...filtered].slice(0, MAX_ITEMS);
        });
    }, []);

    const clear = useCallback(() => setItems([]), []);

    return { items, push, clear };
}
